import { ProductWithAttributes } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

export const getProductWithAttributes = async (
  groupId: string,
  locale: string
): Promise<ProductWithAttributes> => {
  const url = `/group/attributes?ids=${groupId}&include=available&marketLocale=${locale}`;
  const response = await productCatalogueHttp.get<ProductWithAttributes[]>(url);
  return response?.data?.[0];
};
